import ImgBurger from './img/bt_burger.svg'
import ImgBurgerClose from './img/bt_burger_close.svg'
import './navburger.scss'

const NavBurger = ({ handleClick, isMenuOpen }) => {
	return (
		<div
			id="a__navBurger"
			className="is-hidden-widescreen"
			onClick={() => {
				handleClick()
			}}
		>
			<img src={isMenuOpen ? ImgBurgerClose : ImgBurger} />
		</div>
	)
}
export default NavBurger
